(function () {
  function initProductTabPagination(wrapper) {
    if (wrapper.dataset.paginationInitialized === 'true') return;

    var grid = wrapper.querySelector('.product-tab-grid');
    var nav = wrapper.querySelector('[data-pagination-nav]');
    if (!grid || !nav) return;

    var perPage = parseInt(wrapper.dataset.perPage, 10);
    if (!perPage || perPage < 1) return;

    var items = Array.prototype.slice.call(
      grid.querySelectorAll('.product-tab-grid__item:not(.product-card-placeholder)')
    );
    var totalPages = Math.max(1, Math.ceil(items.length / perPage));

    function hideNav() {
      nav.classList.add('product-tab-pagination--hidden');
      nav.setAttribute('aria-hidden', 'true');
    }

    function showNav() {
      nav.classList.remove('product-tab-pagination--hidden');
      nav.removeAttribute('aria-hidden');
    }

    if (items.length <= perPage || totalPages <= 1) {
      hideNav();
      wrapper.dataset.paginationInitialized = 'true';
      return;
    }

    showNav();

    var prevBtn = nav.querySelector('[data-pagination-prev]');
    var nextBtn = nav.querySelector('[data-pagination-next]');
    var infoEl = nav.querySelector('[data-pagination-info]');
    var pageTemplate = wrapper.dataset.pageOfTemplate || 'Page {{ current }} of {{ total }}';
    var currentPage = 1;

    function renderPage(page) {
      currentPage = Math.max(1, Math.min(page, totalPages));

      items.forEach(function (item, index) {
        var itemPage = Math.floor(index / perPage) + 1;
        item.classList.toggle('product-tab-grid__item--hidden', itemPage !== currentPage);
      });

      if (prevBtn) prevBtn.disabled = currentPage <= 1;
      if (nextBtn) nextBtn.disabled = currentPage >= totalPages;

      if (infoEl) {
        infoEl.textContent = pageTemplate
          .replace('{{ current }}', currentPage)
          .replace('{{ total }}', totalPages);
      }
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        renderPage(currentPage - 1);
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        renderPage(currentPage + 1);
      });
    }

    wrapper.__productTabPaginationReset = function () {
      renderPage(1);
    };

    renderPage(1);
    wrapper.dataset.paginationInitialized = 'true';
  }

  function initSection(sectionEl) {
    sectionEl.querySelectorAll('[data-product-tab-pagination]').forEach(initProductTabPagination);
  }

  function bindTabResets() {
    document.querySelectorAll('.product-tab-wrapper .tablinks').forEach(function (tab) {
      if (tab.dataset.paginationBound === 'true') return;
      tab.dataset.paginationBound = 'true';

      tab.addEventListener('click', function () {
        var tabId = tab.id;
        if (!tabId) return;

        document.querySelectorAll('[data-tab="' + tabId + '"][data-product-tab-pagination]').forEach(function (panel) {
          if (typeof panel.__productTabPaginationReset === 'function') {
            panel.__productTabPaginationReset();
          }
        });
      });
    });
  }

  function initAll() {
    document.querySelectorAll('.product-tab-wrapper').forEach(initSection);
    bindTabResets();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
